import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess, BASE_URL, formatAmount } from "../../../../../utils/constants";
import {
  insertUpdateBrandingOpportunity_action,
  getBrandingOpportunityDetails_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/brandingOpportunity_action/brandingOpportunity_action";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import $ from "jquery";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import moment from "moment";
import VendorDetails from "../../vendorDetails";
import VisitorHeader2 from "../../../../../common_components/visitor_module_header2";
import VisitorDrawer from "../../../../../common_components/visitor_module_drawer";
import VisitorTopMenu from "../../../../../common_components/visitor_module_topmenu";
//
class BrandingApportunityAndAdvertisement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      Is_Agree: false,
      Remark: "",
      CGST: "",
      SGST: "",
      IGST: "",
      Is_AgreeErr: "",
      DeadlineDate: "",
      Is_Required: true,
      carPassessId: "",
      currentDate: moment().format("DD-MM-YYYY"),
      tableList: [],
      totalAmount: "",
      AccountNumber: "",
      BankName: "",
      BeneficiaryName: "",
      IFSCCodeValue: "",
      exhibitorName: "",
      hallNo: "",
      stallNo: "",
      stallType: "",
      area: "",
      sidesOpen: "",
      imagePath: "",
      isOpen: false,
      imageName: "",
      is_View: false,
      StatusID: "",
      RoleID: sessionStorage.getItem("RoleIDSS"),
      CurrencyID: JSON.parse(sessionStorage.getItem("ApplicationDataSS"))?.CurrencyID,
      // isHideSection: sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 16
      isHideSection: sessionStorage.getItem("RoleIDSS") != 3 && sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      ActualDeadline:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.ActualDeadline != ""
          ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
          : "",
      IsIGST: false,
      InvPersonName: '',
      InvCompanyName: '',
      InvPrimaryEmail: '',
      InvMobileNo: '',
    };
    // this.getPowerConnectionList = this.getPowerConnectionList.bind(this)
    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.addUpdateBrandingOpportunity(popArg[0])
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("isIndirectAccess") == 'true' ? false : sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 3,
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != null
          ? this.props.location.state.StatusID
          : "",
    });

    const sortUrl = BASE_URL.split("/api");

    this.setState({ downloadUrl: sortUrl[0] });

    this.getBrandingOpportunityDetails();
    this.loadscript();
  }
  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleCancel() {
    window.history.back();
  }

  inputValidate() {
    const { Is_Agree } = this.state;

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({
        Is_AgreeErr: "kindly agree to disclaimer mentioned in this form for Car park passes",
      });
    }
  }

  getBrandingOpportunityDetails() {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getBrandingOpportunityDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });

          if (data.listDataDetails != "") {
            data.listDataDetails.map((item) => {
              data.listData.map((data, i) => {
                if (data.BrandingOppotunityID == item.BrandingOppotunityID) {
                  data.Amount = item.Amount;
                  data.Quantity = item.Quantity != 0 ? item.Quantity : "";
                  data.AvailableQty = data.AvailableQty + item.Quantity;
                  data.LocationNo = item.LocationNo;
                }
              });
            });

            data.listData.map((item) => {
              if (item.Amount == undefined) {
                item.Amount = 0;
              }
            });

            console.log("newArray----------", data.listData);
            const totalAmount = this.sumOfObject(data.listData, "Amount");
            this.setState({ tableList: data.listData, totalAmount: totalAmount });
          } else {
            data.listData.map((data, i) => {
              data.Amount = 0;
              data.Quantity = "";
            });
            const totalAmount = this.sumOfObject(data.listData, "Amount");
            this.setState({ tableList: data.listData, totalAmount: totalAmount });
          }

          if (data.inputData != "") {
            this.setState({ Remark: data.inputData[0]["Remark"] });
          }

          this.setState({
            AccountNumber: data.bankDetails[0]["AccountNumber"],
            BankName: data.bankDetails[0]["BankName"],
            BeneficiaryName: data.bankDetails[0]["BeneficiaryName"],
            IFSCCodeValue: data.bankDetails[0]["code"],
            CGST: data.gst[0]["CGST"] * 100,
            SGST: data.gst[0]["SGST"] * 100,
            IGST: data.gst[0]["IGST"] * 100,
            exhibitorName: data.exhibitorDetails[0]["CompanyName"],
            hallNo: data.exhibitorDetails[0]["HallName"],
            stallNo: data.exhibitorDetails[0]["StallName"],
            stallType: data.exhibitorDetails[0]["StallTypeName"],
            area: data.exhibitorDetails[0]["StallArea"],
            sidesOpen: data.exhibitorDetails[0]["OpenSides"],
            IsIGST: data.IGST[0]['IsIGST'],
            InvPersonName: data.exhibitorDetails[0]["InvPersonName"],
            InvCompanyName: data.exhibitorDetails[0]["InvCompanyName"],
            InvPrimaryEmail: data.exhibitorDetails[0]["InvPrimaryEmail"],
            InvMobileNo: data.exhibitorDetails[0]["InvMobileNo"],
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  addUpdateBrandingOpportunity(e) {
    e.preventDefault();
    const { Remark, tableList } = this.state;
    const newArray = [];

    const qtyWithoutLocation = tableList.some(
      item =>
        item.Quantity != 0 &&
        item.Quantity != '' &&
        item.Quantity != null &&
        (item.LocationNo == '' || item.LocationNo == null)
    )

    const locationWithoutQty = tableList.some(
      item =>
        item.LocationNo != '' &&
        item.LocationNo != null &&
        (item.Quantity == 0 || item.Quantity == '' || item.Quantity == null)
    )

    console.log("qtyWithoutLocation-->", qtyWithoutLocation)
    console.log("locationWithoutQty-->", locationWithoutQty)

    if (qtyWithoutLocation) {
      return toastError("Please Enter Location No. against quantity")
    }

    if (locationWithoutQty) {
      return toastError("Please Enter Quantity against Location No.")
    }

    tableList.map((data) => {
      if (data.Quantity != 0 && data.Quantity != "" && data.Quantity != null && data.LocationNo != "" && data.LocationNo != null) {
        newArray.push({
          BrandingOppotunityID: parseInt(data.BrandingOppotunityID),
          Quantity: parseInt(data.Quantity),
          LocationNo: data.LocationNo,
        });
      }
    });


    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};

    this.setState({ isLoading: true });
    this.props
      .insertUpdateBrandingOpportunity_action(
        Remark,
        newArray,
        ManualFormsID,
        ServiceID,
        VendorDetails
      )
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess(
            this.state.StatusID == 0
              ? "Branding Opportunity Form Submitted Successfully"
              : "Branding Opportunity Form Updated Successfully"
          );
          setTimeout(() => {
            this.handleCancel()
          }, 2000);
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  onChangeInput(e, index, param) {
    const { tableList } = this.state;
    const event = e.target.value.replace(/\D/, "");
    console.log(event, "ppp");
    tableList.map((data, i) => {
      if (i === index) {
        if (param == "Quantity") {
          data.Quantity = event;
          data.Amount = event * data.Charges;
          // if (event != "") {
          //   if (event <= (data.AvailableQty)) {
          //     data.Quantity = event;
          //     data.Amount = event * data.Charges;
          //   } else {
          //     data.Quantity = "";
          //     data.Amount = "";
          //     toastError("Enter Quantity must be less than or equal to Available Quantity");
          //   }
          // } else {
          //   data.Quantity = "";
          //   data.Amount = 0;
          // }
        } else if (param == "LocationNo") {
          data.LocationNo = e.target.value;
        }
      }
    });
    const totalAmount = this.sumOfObject(tableList, "Amount");
    this.setState({ tableList: tableList, totalAmount: totalAmount });
  }

  sumOfObject(arrayOfObjects, propertyName) {
    return arrayOfObjects.reduce((accumulator, currentObject) => {
      return accumulator + currentObject[propertyName];
    }, 0);
  }

  showImage(imagepath, name) {
    this.setState({
      imagePath: imagepath,
      isOpen: true,
      imageName: name,
    });
  }

  render() {
    const {
      isLoading,
      Is_Agree,
      Remark,
      Is_AgreeErr,
      currentDate,
      DeadlineDate,
      tableList,
      totalAmount,
      CGST,
      SGST,
      IGST,
      RoleID,
      AccountNumber,
      BankName,
      BeneficiaryName,
      IFSCCodeValue,
      exhibitorName,
      hallNo,
      stallNo,
      stallType,
      area,
      sidesOpen,
      CurrencyID,
      isOpen,
      imagePath,
      downloadUrl,
      is_View,
      StatusID,
      ActualDeadline,
      isHideSection,
      IsIGST, isOpenConfirmationModal,
      InvPersonName,
      InvCompanyName,
      InvPrimaryEmail,
      InvMobileNo,
    } = this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));

    console.log("is_View", is_View);
    return (
      <>
        <ToastContainer />
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        {!isHideSection && (
          <>
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 3 ?
              <>
                <VisitorHeader2 />
                <VisitorDrawer />
              </> :
              <>
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
                  <ExhibitorHeader />
                ) : (
                  <HeaderWithLogo />
                )}
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
                  <ExhibitorDrawer />
                ) : (
                  <AdminDrawer />
                )}
              </>
            }
          </>
        )}
        <div
          className={!isHideSection ? "with-dr-container" : ""}
          style={{ marginTop: RoleID == 1 ? "0px" : "" }}
        >
          <div className="">
            {!isHideSection && (
              <div className={RoleID == 3 ? "row mt-3" : "row mt-4"}>
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 3 ?
                  <VisitorTopMenu />
                  : <>
                    {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
                      JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
                      <ExhibitorTopMenu />
                    ) : null}
                  </>
                }
              </div>
            )}
            <div className={RoleID == 3 ? "" : ""}>

              <div className="row m-0">
                <div class="card rounded-0 p-0 shadow-none mb-0 border mt-2 m-0">
                  <div class="card-header p-2" style={{ paddingleft: "7px !important" }}>
                    <h3 class="card-title" style={{ fontsize: "15px" }}>
                      Venue Branding & Advertisement
                    </h3>
                  </div>
                  <div class="card-body p-1 m-2">
                    {!isHideSection && (
                      <ol type="1)" style={{ textAlign: "left" }}>
                        <li>
                          The last date for booking display sites and/or submitting advertising material is {ActualDeadline}.
                        </li>
                        <li>
                          India ITME Society reserves the right, at its sole discretion, to make minor alterations to advertisement opportunities.
                        </li>
                        <li>
                          GST will be applicable as per Government rules.
                        </li>
                        <li>
                          All display sites and structures are the sole property of India ITME Society.
                        </li>
                        <li>
                          Display advertising material must be submitted in <strong>CDR, EPS, or TIFF</strong> format via email.
                        </li>
                        <li>
                          Branding opportunities and advertisements will be allocated on a <strong>first-come, first-served basis upon submission of 100% payment</strong>.
                        </li>
                        <li>
                          All billing for on-site branding opportunities and advertisements shall be raised and settled directly by the official vendor. <strong>India ITME Society shall not issue invoices or assume any liability for such payments</strong>.
                        </li>
                        <li>
                          All submitted artwork, designs, text, maps, or other promotional content must comply with the ethics, rules, and values of India ITME Society and must not be politically sensitive. India ITME Society reserves the right to <strong>approve, modify, reject, or remove any on-site branding or advertising material</strong> that it deems misleading, defamatory, unlawful, politically sensitive, or otherwise inconsistent with the event’s standards and presentation.
                        </li>
                        <li>
                          Ready to print files in the mentioned sizes shall be given in PDF / Corel Draw format 15 days prior to the exhibition.
                        </li>
                      </ol>
                    )}
                    {/* {!isHideSection && (
                      <div className="row">
                        <h6 className="mt-2 ">
                          <span className="text-danger">
                            {" "}
                            {console.log("this.props.location?.state?.ActualDeadline--", this.props.location.state)}
                            Last Date Of Submission -{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(this.props.location.state.ActualDeadline).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </span>
                        </h6>
                      </div>
                    )} */}
                    <p style={{ lineHeight: "23px" }}>
                      {/* {!isHideSection &&
                        (CurrencyID == 1 ? (
                          <>
                            <div className="p-1 bg-light border mb-2">
                              <p className="m-0 fw-semibold">Payment Instruction:</p>
                              <ul style={{ listStyleType: "none", margin: 0 }}>
                                <li>DETAILS FOR REMITTANCE:</li>
                                <li>Please remit the funds in favour of "INDIA ITME SOCIETY".</li>
                                <li>
                                  For RTGS/NEFT please refer details below: For RTGS/NEFT please
                                  refer details below:{" "}
                                </li>
                                <li>
                                  Name of the Beneficiary :{" "}
                                  {BeneficiaryName != null ? BeneficiaryName : "-"}{" "}
                                </li>
                                <li>
                                  current account no. :{" "}
                                  {AccountNumber != null ? AccountNumber : "-"}{" "}
                                </li>
                                <li>bank and branch : {BankName != null ? BankName : "-"} </li>
                                <li>IFSC Code : {IFSCCodeValue != null ? IFSCCodeValue : "-"}</li>
                              </ul>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="p-1 bg-light border mb-2">

                              <p className="m-0 fw-semibold">Payment Instruction:</p>

                              <ul style={{ listStyleType: "none", margin: 0 }}>
                                <li>
                                  Name of the Beneficiary :{" "}
                                  {BeneficiaryName != null ? BeneficiaryName : "-"}{" "}
                                </li>
                                <li>
                                  current account no. :{" "}
                                  {AccountNumber != null ? AccountNumber : "-"}{" "}
                                </li>
                                <li>bank and branch : {BankName != null ? BankName : "-"} </li>
                                <li>IFSC Code : {IFSCCodeValue != null ? IFSCCodeValue : "-"}</li>
                              </ul>
                            </div>
                          </>
                        ))} */}
                      {exhibitorName || InvPersonName ?
                        <div className="p-1 bg-light border mb-2 d-flex">

                          {/* Exhibitor Details */}
                          {exhibitorName ?
                            <div style={{ width: "450px" }}>
                              <p className="m-0 fw-semibold">{JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 3 ? "Visitor Details" : "Exhibitor Details"}</p>

                              <ul className="p-0 m-0" style={{ listStyle: "none" }}>
                                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                                  <span>Exhibitor Name</span>
                                  <span>: {exhibitorName || "-"}</span>
                                </li>

                                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                                  <span>Stall Type</span>
                                  <span>: {stallType || "-"}</span>
                                </li>

                                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                                  <span>Area</span>
                                  <span>: {area || "-"}</span>
                                </li>
                              </ul>
                            </div> : ''
                          }

                          {/* Invoice Details */}
                          {InvPersonName ?
                            <div style={{ paddingLeft: "100px" }}>
                              <p className="m-0 fw-semibold">{JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 3 ? "Visitor" : "Exhibitor"} Invoice Details</p>

                              <ul className="p-0 m-0" style={{ listStyle: "none" }}>
                                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                                  <span>Person Name</span>
                                  <span>: {InvPersonName || "-"}</span>
                                </li>

                                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                                  <span>Company Name</span>
                                  <span>: {InvCompanyName || "-"}</span>
                                </li>

                                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                                  <span>Email</span>
                                  <span>: {InvPrimaryEmail || "-"}</span>
                                </li>

                                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                                  <span>Mobile No.</span>
                                  <span>: {InvMobileNo || "-"}</span>
                                </li>
                              </ul>
                            </div> : ''
                          }

                        </div> : ''
                      }


                      <VendorDetails />
                    </p>




                  </div>
                </div>

                <div class="table-responsive p-0 mt-2">
                  <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Particular and Size</th>
                        <th className="text-center">Image Location</th>
                        {/* <th className="text-end">Available Quantity</th> */}
                        {/* {!isHideSection && ( */}
                        <th className="text-end">
                          Cost Per Unit
                          {/* {CurrencyID == 1 ? "(INR)" : "(USD)"} */}
                        </th>
                        {/* )} */}
                        <th className="text-end" style={{ width: '200px' }}>Quantity</th>
                        <th>Location No</th>
                        {/* {!isHideSection && <th className="text-end">Amount</th>}
                        <th className="text-end">Total Quantity</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {tableList != "" && tableList != null && tableList.length > 0 ? (
                        tableList.map((data, i) => (
                          (isHideSection ? data.Quantity != '' && data.Quantity != null : true) &&
                          <tr>
                            {console.log("data.Quantity != '' && data.Quantity != null", data.Quantity != '' && data.Quantity != null)}
                            <td>{i + 1}</td>
                            <td>
                              {data.ParticularAndSize != null ? data.ParticularAndSize : "-"}
                            </td>
                            <td style={{ textAlign: "center", cursor: "pointer" }}>
                              {data.ImagePath != null ? (
                                <i
                                  class="fa fa-image grid-icon"
                                  onClick={() =>
                                    this.showImage(data.ImagePath, data.ParticularAndSize)
                                  }
                                ></i>
                              ) : (
                                "-"
                              )}
                            </td>
                            {/* <td className="text-end">
                              {" "}
                              {data.AvailableQty != null ? data.AvailableQty : "-"}
                            </td> */}
                            {/* {!isHideSection && ( */}
                            <td style={{ textAlign: "right" }}>
                              {formatAmount(data.Charges != null ? data.Charges : "-")}
                            </td>
                            {/* )} */}
                            <td className="p-1">
                              <input
                                type="text"
                                className="form-control text-end"
                                value={data.Quantity}
                                onChange={(e) => this.onChangeInput(e, i, "Quantity")}
                                maxLength={5}
                                disabled={
                                  // data.AvailableQty == 0 ||
                                  isDeadlinePassed ||
                                  is_View ||
                                  StatusID == 2
                                }
                              />
                            </td>
                            <td className="p-1">
                              <input
                                type="text"
                                className="form-control"
                                value={data.LocationNo}
                                onChange={(e) => this.onChangeInput(e, i, "LocationNo")}
                                maxLength={200}
                                disabled={isDeadlinePassed || is_View || StatusID == 2}
                              />
                            </td>
                            {/* {!isHideSection && (
                              <td style={{ textAlign: "right" }}>
                                {formatAmount(
                                  data.Amount != null && data.Amount != "" ? data.Amount : 0
                                )}
                              </td>
                            )}
                            <td className="text-end">
                              {data.TotalQty != null ? data.TotalQty : "-"}
                            </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center" colSpan={9}>
                            No record found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {!isHideSection && (
                    <div className="p-1 bg-light border mb-2">
                      <p className="m-0 fw-semibold">
                        Note:
                      </p>

                      <ul style={{ listStyleType: "number", textAlign: "left", margin: 0 }}>
                        <li>Payment Terms: 100% advance</li>
                        <li>Taxes extra as applicable </li>
                      </ul>
                    </div>
                  )}

                  {/* {!isHideSection && ( */}
                  <div className="p-1 bg-light border mb-1 mt-3">
                    <p className="m-0 fw-semibold">Estimate Amount:</p>

                    <ul style={{ listStyleType: "decimal", margin: 0 }}>

                      <li style={{ display: "grid", gridTemplateColumns: "150px 10px 120px" }}>
                        <span className='text-left'>Amount</span>
                        <span>:</span>
                        <span style={{ textAlign: "right" }}>
                          {formatAmount(Number(totalAmount) || 0)}
                        </span>
                      </li>

                      {!IsIGST ? (
                        <>
                          <li style={{ display: "grid", gridTemplateColumns: "150px 10px 120px" }}>
                            <span className='text-left'>CGST {CGST}%</span>
                            <span>:</span>
                            <span style={{ textAlign: "right" }}>
                              {formatAmount(Math.round((CGST / 100) * Number(totalAmount)))}
                            </span>
                          </li>

                          <li style={{ display: "grid", gridTemplateColumns: "150px 10px 120px" }}>
                            <span className='text-left'>SGST {SGST}%</span>
                            <span>:</span>
                            <span style={{ textAlign: "right" }}>
                              {formatAmount(Math.round((SGST / 100) * Number(totalAmount)))}
                            </span>
                          </li>
                        </>
                      ) : (
                        <li style={{ display: "grid", gridTemplateColumns: "150px 10px 120px" }}>
                          <span className='text-left'>IGST {IGST}%</span>
                          <span>:</span>
                          <span style={{ textAlign: "right" }}>
                            {formatAmount(Math.round((IGST / 100) * Number(totalAmount)))}
                          </span>
                        </li>
                      )}

                      <li
                        style={{
                          display: "grid",
                          gridTemplateColumns: "150px 10px 120px",
                          fontWeight: "bold",
                        }}
                      >
                        <span className='text-left'>Total Amount</span>
                        <span>:</span>
                        <span style={{ textAlign: "right" }}>
                          {formatAmount(
                            Math.round(
                              Number(totalAmount) +
                              (CGST / 100) * Number(totalAmount) +
                              (SGST / 100) * Number(totalAmount)
                            )
                          )}
                        </span>
                      </li>

                    </ul>
                  </div>
                  {/* )} */}
                </div>

                {/* {!isHideSection && ( */}
                <div className="mt-2 p-0 mb-3">
                  {" "}
                  <label>Additional Note</label>
                  <textarea
                    class="form-control"
                    value={Remark}
                    onChange={(e) => this.setState({ Remark: e.target.value })}
                    maxLength={300}
                    disabled={isDeadlinePassed || is_View || StatusID == 2}
                    rows="3"
                  ></textarea>
                </div>
                {/* )} */}
                {/* <div class="row m-1"> */}
              </div>
              {!isHideSection && (
                <div className="row m-0">
                  {currentDate > DeadlineDate && (
                    <span className="text-danger">
                      THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                    </span>
                  )}
                </div>
              )}
              {!isHideSection && (
                <div class="d-flex justify-content-end mt-0">
                  {!is_View ? (
                    <button
                      type="button"
                      className="btn btn-aqua rounded-1 d-block"
                      style={{ marginRight: 10 }}
                      disabled={isDeadlinePassed || StatusID == 2}
                      onClick={(e) => this.addUpdateBrandingOpportunity(e)}
                    // onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                    >
                      {this.state.StatusID == 0 ? "Submit" : "Update"}
                    </button>
                  ) : (
                    <></>
                  )}
                  <button
                    className="btn btn-gray rounded-1 d-block"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <Modal show={isOpen} onHide={() => this.setState({ isOpen: false })} size="xl" style={{ zIndex: '99999' }}>
          <Modal.Header>
            <Modal.Title> Image Location</Modal.Title>
            <span
              onClick={() => this.setState({ isOpen: false })}
              style={{ cursor: "pointer", fontWeight: "800" }}
            >
              X
            </span>
          </Modal.Header>

          <Modal.Body style={{ marginBottom: "0px", textAlign: "center" }}>
            {console.log("image-----", downloadUrl + imagePath)}
            <img alt="" title="" src={downloadUrl + imagePath} className="booking_page_img" />
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, { insertUpdateBrandingOpportunity_action, getBrandingOpportunityDetails_action })(
    BrandingApportunityAndAdvertisement
  )
);